import React from "react";
import PropTypes from "prop-types";
import { Field, ErrorMessage } from "formik";

const FormikFieldLeftAligned = ({
  name,
  label,
  labelAppend,
  style,
  className,
  inlineError,
  requiredQuestion,
  ...rest
}) => (
  <span className={className} style={style}>
    <span className="form-field-header" style={{alignItems: "center"}}>
      <Field name={name} {...rest} id={name} className="input-field" />
      {label && (
        <label className="form-field-label" style={requiredQuestion ? {marginRight: "0"} : undefined} htmlFor={name}>
          {label}
        </label>
      )}
      {requiredQuestion && (
        <label style={{color: "red"}} htmlFor={name}>
            *
        </label>
      )}
      {labelAppend && (
        <label className="form-field-label-append" htmlFor={labelAppend}>
          {`* ${labelAppend}`}
        </label>
      )}
    </span>
    {!inlineError && (
        <span className="form-field-error">
            <ErrorMessage name={name} />
        </span>
    )}
    
    {inlineError && (
        <span className="form-field-error-inline">
            <ErrorMessage name={name} />
        </span>
    )}
  </span>
);
export default FormikFieldLeftAligned;

FormikFieldLeftAligned.propTypes = {
  name: PropTypes.string.isRequired,
  labelAppend: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  style: PropTypes.object,
  className: PropTypes.string,
  inlineError: PropTypes.bool,
  requiredQuestion: PropTypes.bool,
};

FormikFieldLeftAligned.defaultProps = { style: {display: "flex"}, className: "form-field" };
